import { IChannel } from '@/api';
import { Site } from './Site';

export class Channel {

    public static fromDto(channelDto: IChannel, sites: Site[]): Channel {

        if (!channelDto) { throw new Error('channelDto is not set'); }

        let sourceSite = null;
        if (channelDto.sourceId && channelDto.sourceId.length > 0) {
            const site = sites.find(x => x.id === channelDto.sourceId);
            if (site) {
                sourceSite = site;
            }
        }

        let destinationSite = null;
        if (channelDto.destinationId && channelDto.destinationId.length > 0) {
            const site = sites.find(x => x.id === channelDto.destinationId);
            if (site) {
                destinationSite = site;
            }
        }

        return new Channel(
            channelDto.id,
            channelDto.name || channelDto.id,
            sourceSite,
            destinationSite,
        );
    }

    public readonly id: string;
    public readonly name: string;
    public readonly source: Site | null;
    public readonly destination: Site | null;

    constructor(
        id: string,
        name: string,
        source: Site | null,
        destination: Site | null
    ) {
        this.id = id;
        this.name = name;
        this.source = source;
        this.destination = destination;
    }
}
